function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { autoGravity, focusOn } from "../../qualifiers/gravity.js";
import { FocusOnValue, ocr } from "../../qualifiers/focusOn.js";
import { AutoFocus } from "../../qualifiers/autoFocus.js";
import { CompassGravity } from "../../qualifiers/gravity/compassGravity/CompassGravity.js";
import { CompassQualifier } from "../../qualifiers/gravity/qualifiers/compass/CompassQualifier.js";
/**
 * Validates that gravityModel is an ICompassGravityModel
 * @param gravityModel
 */

function isCompassGravityModel(gravityModel) {
  return gravityModel.gravityType === 'direction';
}
/**
 * Validates that gravityModel is an IOcrGravityModel
 * @param gravityModel
 */


function isOcrGravityModel(gravityModel) {
  return gravityModel.gravityType === 'ocr';
}
/**
 * Validates that gravityModel is an IAutoGravityModel
 * @param gravityModel
 */


function isAutoGravityModel(gravityModel) {
  return gravityModel.gravityType === 'auto';
}
/**
 * Create AutoFocus from IAutoGravityObjectModel
 * @param autoGravityObjectModel
 */


function createAutoFocusFromModel(autoGravityObjectModel) {
  var object = autoGravityObjectModel.object,
      weight = autoGravityObjectModel.weight,
      avoid = autoGravityObjectModel.avoid;
  var autoFocus = new AutoFocus(new FocusOnValue(object));
  (weight || weight === 0) && autoFocus.weight(weight);
  avoid && autoFocus.avoid();
  return autoFocus;
}
/**
 * Create AutoGravity from IAutoGravityModel
 * @param gravityModel
 */


function createAutoGravityFromModel(gravityModel) {
  var _autoGravity;

  var autoFocusModel = gravityModel.autoFocus || [];
  var autoFocus = autoFocusModel.map(createAutoFocusFromModel);
  return (_autoGravity = autoGravity()).autoFocus.apply(_autoGravity, _toConsumableArray(autoFocus));
}
/**
 * Create FocusOnGravity from given IFocusOnGravityModel
 * @param gravityModel
 */


function createFocusOnGravityFromModel(gravityModel) {
  var focusOnObjects = (gravityModel.focusOnObjects || []).map(function (str) {
    return new FocusOnValue(str);
  });
  var result = focusOn.apply(void 0, _toConsumableArray(focusOnObjects));

  if (gravityModel.fallbackGravity) {
    var _autoGravity2 = createAutoGravityFromModel(gravityModel.fallbackGravity);

    result.fallbackGravity(_autoGravity2);
  }

  return result;
}
/**
 * Create gravity instance from given gravity model
 * @param gravityModel
 */


function createGravityFromModel(gravityModel) {
  if (isCompassGravityModel(gravityModel)) {
    return new CompassGravity(new CompassQualifier(gravityModel.compass));
  }

  if (isOcrGravityModel(gravityModel)) {
    return focusOn(ocr());
  }

  if (isAutoGravityModel(gravityModel)) {
    return createAutoGravityFromModel(gravityModel);
  }

  return createFocusOnGravityFromModel(gravityModel);
}

export { createGravityFromModel };